import InitVueApp from '@/entry';
import store from '@/apps/searchbar/store';
import { appElement } from '../config';
import App from './App';

new InitVueApp(App, appElement, { store });
